import api from "./index";

export interface CourseListParams {
  ids?: Array<string>;
  title?: string;
  enabled?: boolean;
  ownerIds?: Array<string>;
  responsibleIds?: Array<string>;
  listenerIds?: Array<string>;
  listenerUserIds?: Array<string>;
  companyIds?: Array<string>;
  categoryIds?: Array<string>;
  price?: number;
  hours?: number;
  locale?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "id" | "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  mode?: "v1" | "v2";
  options?: any;
}

export default (params: CourseListParams, options?: any) => {
  return api.CourseApi.list(
    params.ids,
    params.title,
    params.enabled,
    params.ownerIds,
    params.responsibleIds,
    params.listenerIds,
    params.listenerUserIds,
    params.companyIds,
    params.categoryIds,
    params.price,
    params.hours,
    params.locale,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.mode,
    params.options
  );
};
